export const AUTH_STEP = {
  LOGIN: "LOGIN",
  REGISTER: "REGISTER",
}

export const DISCORD_SSO_OPTIONS = {
  clientId: process.env.DISCORD_CLIENT_ID,
  redirectURI: process.env.DISCORD_REDIRECT_URI,
  responseType: "code",
  responseScope: "email identify",
}

export const AIM_LAB_SSO_OPTIONS = {
  oauthEndpoint: process.env.AIM_LAB_OAUTH_ENDPOINT,
  clientId: process.env.AIMLAB_CLIENT_ID,
  redirectURI: process.env.AIM_LAB_REDIRECT_URI,
  responseType: "code",
  responseScope: "user creator",
}



// WEBPACK FOOTER //
// ./src/store/auth/auth.constants.js